// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1Obcz","clinicsSelect":"TableHeading_clinicsSelect__1a3cP"};